// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NuevaDiligenciaForm — create/edit form; shared field primitives (@/ui Form)
   plus a small autocomplete combo for the causa picker and comuna·región. */

/* Read-only derived value (Corte / Tribunal / locked causa). */
.ndf-fixed {
  font-size: var(--fs-ui);
  color: var(--ink-2);
  padding: 8px 0;
}

/* Autocomplete combo (causa picker + comuna·región). */
.ndf-combo {
  position: relative;
}
.ndf-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: var(--z-dropdown, 40);
  background: var(--paper-elev, #fff);
  border: 1px solid var(--rule);
  box-shadow: var(--shadow, 0 6px 24px rgba(0, 0, 0, 0.1));
  max-height: 260px;
  overflow-y: auto;
}
.ndf-menu-head {
  padding: 8px 12px 4px;
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
}
.ndf-opt {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  border-bottom: 1px solid var(--rule-soft);
  padding: 9px 12px;
  cursor: pointer;
  font: inherit;
  color: var(--ink);
}
.ndf-opt:last-child {
  border-bottom: 0;
}
.ndf-opt:hover {
  background: var(--surface);
}
.ndf-opt b {
  font-family: var(--mono);
  font-size: var(--fs-ui);
  font-weight: 500;
}
.ndf-opt-sub {
  font-size: 12.5px;
  color: var(--ink-2);
}
.ndf-opt-reg {
  font-size: var(--fs-meta);
  color: var(--ink-3);
}
.ndf-opt-empty {
  padding: 12px;
  font-size: var(--fs-ui);
  color: var(--ink-3);
}

/* Espacio para las instrucciones del receptor. */
.ndf-notas.form-input.tall {
  min-height: 144px;
}

/* Action row. */
.ndf-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
}

/* Secciones del formulario (REC-1966): qué se pide, y dónde y plazo. */
.ndf-section {
  margin: 18px 0 2px;
  padding-top: 14px;
  border-top: 1px solid var(--rule);
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
}

/* Un grupo con su leyenda en la columna de las etiquetas. */
.ndf-group {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}
.ndf-group__legend {
  padding: 11px 0 4px;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
}
.ndf-group > .helper-text,
.ndf-group > .ndf-link {
  margin-left: 144px;
}

/* La inscripción: cuatro campos con la etiqueta encima. */
.ndf-grid4 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 0 10px;
}
.ndf-grid4 .input-row {
  grid-template-columns: 1fr;
  gap: 4px;
  padding: 4px 0;
}
.ndf-grid4 .input-row > .helper-text {
  grid-column: 1;
  margin-top: 0;
}

/* Fila con etiqueta y un control que no es un campo: contadores, tipo de
   domicilio. Calza con la grilla de InputRow. */
.ndf-recipient-row {
  display: grid;
  grid-template-columns: 130px auto 1fr;
  gap: 14px;
  align-items: center;
  padding: 7px 0;
}
.ndf-recipient-row > span {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
}
.ndf-recipient-row > .ndf-link {
  justify-self: start;
}

.ndf-counter {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.ndf-counter__n {
  min-width: 24px;
  text-align: center;
  font-family: var(--mono);
  font-weight: 500;
}

.ndf-seg {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* Acción secundaria con forma de link. */
.ndf-link {
  background: none;
  border: 0;
  padding: 4px 0;
  font: inherit;
  font-size: var(--fs-ui);
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.ndf-link:disabled {
  color: var(--ink-3);
  text-decoration: none;
  cursor: default;
}

/* El domicilio propio de cada destinatario, cuando alguno lo tiene. */
.ndf-domicilios {
  display: grid;
  gap: 8px;
  margin: 6px 0 0 144px;
}
.ndf-domicilio {
  border: 1px solid var(--rule);
  margin: 0;
  padding: 8px 12px;
  min-width: 0;
}
/* La leyenda va dentro de la caja, no sobre el borde. */
.ndf-domicilio > legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 2px;
}
.ndf-domicilio > legend + * {
  clear: both;
}
/* Dentro de la caja, la etiqueta va sobre el campo: no cabe al lado. */
.ndf-domicilio .input-row,
.ndf-domicilio .ndf-recipient-row {
  grid-template-columns: 1fr;
  gap: 4px;
  padding: 4px 0;
}
.ndf-domicilio .input-row > .helper-text {
  grid-column: 1;
  margin-top: 0;
}
.ndf-domicilio__who {
  margin: 0;
  font-size: var(--fs-ui);
  font-weight: 500;
  color: var(--ink);
}

@media (max-width: 560px) {
  .ndf-recipient-row {
    grid-template-columns: 1fr auto;
  }
  .ndf-recipient-row > .ndf-link {
    grid-column: 1 / -1;
  }
  .ndf-group > .helper-text,
  .ndf-group > .ndf-link,
  .ndf-domicilios {
    margin-left: 0;
  }
}

.ndf-opt-notfound a {
  color: var(--accent);
}
`, "",{"version":3,"sources":["webpack://./src/pages/diligencias/NuevaDiligenciaForm.css"],"names":[],"mappings":"AAAA;4EAC4E;;AAE5E,+DAA+D;AAC/D;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,mCAAmC;EACnC,6BAA6B;EAC7B,wDAAwD;EACxD,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;gDACgD;AAChD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;AACA,wDAAwD;AACxD;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA,uEAAuE;AACvE;;EAEE,0BAA0B;EAC1B,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/* NuevaDiligenciaForm — create/edit form; shared field primitives (@/ui Form)\n   plus a small autocomplete combo for the causa picker and comuna·región. */\n\n/* Read-only derived value (Corte / Tribunal / locked causa). */\n.ndf-fixed {\n  font-size: var(--fs-ui);\n  color: var(--ink-2);\n  padding: 8px 0;\n}\n\n/* Autocomplete combo (causa picker + comuna·región). */\n.ndf-combo {\n  position: relative;\n}\n.ndf-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: var(--z-dropdown, 40);\n  background: var(--paper-elev, #fff);\n  border: 1px solid var(--rule);\n  box-shadow: var(--shadow, 0 6px 24px rgba(0, 0, 0, 0.1));\n  max-height: 260px;\n  overflow-y: auto;\n}\n.ndf-menu-head {\n  padding: 8px 12px 4px;\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n.ndf-opt {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  border-bottom: 1px solid var(--rule-soft);\n  padding: 9px 12px;\n  cursor: pointer;\n  font: inherit;\n  color: var(--ink);\n}\n.ndf-opt:last-child {\n  border-bottom: 0;\n}\n.ndf-opt:hover {\n  background: var(--surface);\n}\n.ndf-opt b {\n  font-family: var(--mono);\n  font-size: var(--fs-ui);\n  font-weight: 500;\n}\n.ndf-opt-sub {\n  font-size: 12.5px;\n  color: var(--ink-2);\n}\n.ndf-opt-reg {\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n}\n.ndf-opt-empty {\n  padding: 12px;\n  font-size: var(--fs-ui);\n  color: var(--ink-3);\n}\n\n/* Espacio para las instrucciones del receptor. */\n.ndf-notas.form-input.tall {\n  min-height: 144px;\n}\n\n/* Action row. */\n.ndf-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n/* Secciones del formulario (REC-1966): qué se pide, y dónde y plazo. */\n.ndf-section {\n  margin: 18px 0 2px;\n  padding-top: 14px;\n  border-top: 1px solid var(--rule);\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  font-weight: 500;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n/* Un grupo con su leyenda en la columna de las etiquetas. */\n.ndf-group {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n}\n.ndf-group__legend {\n  padding: 11px 0 4px;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n}\n.ndf-group > .helper-text,\n.ndf-group > .ndf-link {\n  margin-left: 144px;\n}\n\n/* La inscripción: cuatro campos con la etiqueta encima. */\n.ndf-grid4 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: 0 10px;\n}\n.ndf-grid4 .input-row {\n  grid-template-columns: 1fr;\n  gap: 4px;\n  padding: 4px 0;\n}\n.ndf-grid4 .input-row > .helper-text {\n  grid-column: 1;\n  margin-top: 0;\n}\n\n/* Fila con etiqueta y un control que no es un campo: contadores, tipo de\n   domicilio. Calza con la grilla de InputRow. */\n.ndf-recipient-row {\n  display: grid;\n  grid-template-columns: 130px auto 1fr;\n  gap: 14px;\n  align-items: center;\n  padding: 7px 0;\n}\n.ndf-recipient-row > span {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n}\n.ndf-recipient-row > .ndf-link {\n  justify-self: start;\n}\n\n.ndf-counter {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.ndf-counter__n {\n  min-width: 24px;\n  text-align: center;\n  font-family: var(--mono);\n  font-weight: 500;\n}\n\n.ndf-seg {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* Acción secundaria con forma de link. */\n.ndf-link {\n  background: none;\n  border: 0;\n  padding: 4px 0;\n  font: inherit;\n  font-size: var(--fs-ui);\n  color: var(--accent);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n.ndf-link:disabled {\n  color: var(--ink-3);\n  text-decoration: none;\n  cursor: default;\n}\n\n/* El domicilio propio de cada destinatario, cuando alguno lo tiene. */\n.ndf-domicilios {\n  display: grid;\n  gap: 8px;\n  margin: 6px 0 0 144px;\n}\n.ndf-domicilio {\n  border: 1px solid var(--rule);\n  margin: 0;\n  padding: 8px 12px;\n  min-width: 0;\n}\n/* La leyenda va dentro de la caja, no sobre el borde. */\n.ndf-domicilio > legend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 2px;\n}\n.ndf-domicilio > legend + * {\n  clear: both;\n}\n/* Dentro de la caja, la etiqueta va sobre el campo: no cabe al lado. */\n.ndf-domicilio .input-row,\n.ndf-domicilio .ndf-recipient-row {\n  grid-template-columns: 1fr;\n  gap: 4px;\n  padding: 4px 0;\n}\n.ndf-domicilio .input-row > .helper-text {\n  grid-column: 1;\n  margin-top: 0;\n}\n.ndf-domicilio__who {\n  margin: 0;\n  font-size: var(--fs-ui);\n  font-weight: 500;\n  color: var(--ink);\n}\n\n@media (max-width: 560px) {\n  .ndf-recipient-row {\n    grid-template-columns: 1fr auto;\n  }\n  .ndf-recipient-row > .ndf-link {\n    grid-column: 1 / -1;\n  }\n  .ndf-group > .helper-text,\n  .ndf-group > .ndf-link,\n  .ndf-domicilios {\n    margin-left: 0;\n  }\n}\n\n.ndf-opt-notfound a {\n  color: var(--accent);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
